export default __webpack_public_path__ + "static/Group-148809-b53e8d7b49a78711011fc2b16ef1ce16.png";